import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsPreview = ({ member, settings, activeTab }) => {
  const renderPreview = () => {
    if (activeTab === 'account') {
      return (
        <div className="space-y-4">
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3 mb-3">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold"
                style={{ backgroundColor: member?.color }}
              >
                {member?.initials}
              </div>
              <div>
                <div className="font-semibold text-foreground">{settings?.accountInfo?.name}</div>
                <div className="text-xs text-muted-foreground">{settings?.accountInfo?.role}</div>
              </div>
            </div>
            <div className="text-xs text-muted-foreground space-y-1">
              {settings?.accountInfo?.email && (
                <div className="flex items-center gap-2">
                  <Icon name="mail" size={12} />
                  <span>{settings?.accountInfo?.email}</span>
                </div>
              )}
              {settings?.accountInfo?.phone && (
                <div className="flex items-center gap-2">
                  <Icon name="phone" size={12} />
                  <span>{settings?.accountInfo?.phone}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (activeTab === 'display') {
      return (
        <div className="space-y-4">
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground mb-2">CALENDAR VIEW</div>
            <div className="bg-card border border-border rounded p-2">
              <div className="text-xs text-foreground capitalize">
                {settings?.displayPreferences?.calendarView} View
              </div>
            </div>
          </div>
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground mb-2">TASK PREVIEW</div>
            <div className="space-y-2">
              <div
                className="p-2 rounded border-l-4 bg-card"
                style={{ borderLeftColor: member?.color }}
              >
                <div className={`text-xs font-medium ${
                  settings?.displayPreferences?.fontSize === 'small' ? 'text-xs' :
                  settings?.displayPreferences?.fontSize === 'large' ? 'text-base' :
                  settings?.displayPreferences?.fontSize === 'xlarge'? 'text-lg' : 'text-sm'
                }`}>
                  Sample Task
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground mb-2">COLOR THEME</div>
            <div className="flex items-center gap-2">
              <div
                className="w-8 h-8 rounded"
                style={{ backgroundColor: settings?.displayPreferences?.colorTheme }}
              />
              <span className="text-xs text-foreground">{settings?.displayPreferences?.colorTheme}</span>
            </div>
          </div>
        </div>
      );
    }

    if (activeTab === 'notifications') {
      return (
        <div className="space-y-4">
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground mb-3">NOTIFICATION PREVIEW</div>
            <div className="bg-card border border-border rounded-lg p-3 space-y-2">
              <div className="flex items-start gap-2">
                <div
                  className="w-2 h-2 rounded-full mt-1"
                  style={{ backgroundColor: member?.color }}
                />
                <div className="flex-1">
                  <div className="text-xs font-medium text-foreground">New Message</div>
                  <div className="text-xs text-muted-foreground">Family group chat</div>
                </div>
                {settings?.notifications?.messages?.sound && (
                  <Icon name="volume-2" size={12} className="text-muted-foreground" />
                )}
              </div>
            </div>
          </div>
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground mb-2">ACTIVE ALERTS</div>
            <div className="space-y-2">
              {settings?.notifications?.messages?.enabled && (
                <div className="flex items-center gap-2 text-xs">
                  <Icon name="message-square" size={12} style={{ color: member?.color }} />
                  <span className="text-foreground">Messages</span>
                </div>
              )}
              {settings?.notifications?.taskReminders?.enabled && (
                <div className="flex items-center gap-2 text-xs">
                  <Icon name="check-square" size={12} style={{ color: member?.color }} />
                  <span className="text-foreground">Task Reminders</span>
                </div>
              )}
              {settings?.notifications?.calendarAlerts?.enabled && (
                <div className="flex items-center gap-2 text-xs">
                  <Icon name="calendar" size={12} style={{ color: member?.color }} />
                  <span className="text-foreground">Calendar Alerts</span>
                </div>
              )}
              {settings?.notifications?.familyActivity?.enabled && (
                <div className="flex items-center gap-2 text-xs">
                  <Icon name="users" size={12} style={{ color: member?.color }} />
                  <span className="text-foreground">Family Activity</span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 sticky top-8">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="eye" size={20} style={{ color: member?.color }} />
        <h3 className="font-semibold text-foreground">Settings Preview</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        See how your settings will appear across the application
      </p>
      {renderPreview()}
    </div>
  );
};

export default SettingsPreview;